import styled from 'styled-components';

interface ControlsContainerProps {
  sidebarVisible: boolean;
  sidebarWidth: number;
  controlsWidth: number;
  height: number | string;
}

export const ControlsContainer = styled.div<ControlsContainerProps>`
  position: fixed;
  top: 0;
  right: ${({ sidebarVisible, sidebarWidth }) => (sidebarVisible ? `${sidebarWidth}px` : `0px`)};
  width: ${({ controlsWidth }) => `${controlsWidth}px`};
  height: ${({ height }) => (typeof height === 'number' ? `${height}px` : height)};
  z-index: 1000;
  background: #fff;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  transition: 500ms;
  border-right: 1px solid #d0d5dd;
`;
